import { UcoastEl } from '@/scripts/core/UcoastEl'
export class InstagramFeed extends UcoastEl {
    static htmlSelector = 'app-block'
    private feedBlock: HTMLElement | null = null;
    private observer: IntersectionObserver | null = null;

    constructor() {
      super();
      // this.feedBlock = document.querySelector('[data-widget-host="habitat-static-feed"], [data-widget-host="habitat-product-feed"]');
      this.feedBlock = document.querySelector('[data-widget-host="habitat-static-feed"]');
    }

    override connectedCallback() {
      if (!this.feedBlock) return;

      const handleIntersection = (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this.feedBlock!);

        const checkfeedBlockEmbed = setInterval(() => {
          const shadowRoot = this.feedBlock!.shadowRoot;
          if (shadowRoot && shadowRoot.querySelector('.shoppables-root')) {
            clearInterval(checkfeedBlockEmbed);
            const shoppablesRoot = shadowRoot.querySelector('.shoppables-root') as HTMLElement;

            if(!shadowRoot.querySelector('img')) {
              this.closest('.app-blocks')?.classList.add('hidden')
              return
            }

            this.closest('.app-blocks')?.classList.remove('hidden')

            shoppablesRoot.style.setProperty('--slide-gap', '8px');
            shoppablesRoot.style.setProperty('--slide-size', '20%');
            shoppablesRoot.style.setProperty('--arrow-size', '0');
            shoppablesRoot.style.setProperty('--arrow-size-new', '0');
            shoppablesRoot.style.padding = '0';

            this.screenResize(shadowRoot);

            window.addEventListener('resize', () => this.screenResize(shadowRoot));
          } else {
            this.closest('.app-blocks')?.classList.add('hidden')
          }
        }, 500);

        setTimeout(() => {
          clearInterval(checkfeedBlockEmbed);
        }, 10000);
      };

      this.observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 400px 0px' });
      this.observer.observe(this.feedBlock);
    }

    private screenResize(shadowRoot: ShadowRoot) {
      const slider = shadowRoot.querySelector('.shoppables-root > div > div > div > div') as HTMLElement;
      const dialogs = shadowRoot.querySelectorAll('[aria-haspopup="dialog"]') as NodeListOf<HTMLElement>;

      if (window.innerWidth >= 768) {
        slider.style.margin = '0 0 0 48px';
        dialogs.forEach(dialog => {
          dialog.style.setProperty('--slide-size', '20%');
          dialog.style.borderRadius = '0';
        });
      } else {
        slider.style.margin = '0 0 0 16px';
        dialogs.forEach(dialog => {
          dialog.style.setProperty('--slide-size', '290px');
          dialog.style.borderRadius = '0';
        });
      }
    }
}
